export default {"src":"/_next/static/media/Browser_Logo.61ca8459.svg","height":64,"width":128,"blurWidth":0,"blurHeight":0};